export const environment = {
  production: false,
  baseUrl: 'https://demo.yurest.dev/api/',
  baseUrlAsst: '',
  pusher: {
    key: '',
    cluster: 'eu',
  },
};
